module.exports = __webpack_public_path__ + "img/tiff.1599c0eb.svg";